module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="fb_albums_wrapper">\n	<div id="fb_albums_container">\n	</div>\n	<div id="load_more" role="button" tabindex="0">' +
((__t = ( I18n.t('uploader.social.load_more') )) == null ? '' : __t) +
'</div>\n</div>';

}
return __p
}